export enum EstimationExportFileFormat {
  PDF = "PDF",
  CSV = "CSV",
  XLSX = "XLSX",
}
